module.exports = __webpack_public_path__ + "static/media/p6_6.009ac8bc.png";